import { useEffect, useState } from 'react';
import type { ProductEntry } from '@/content/products';
import { fetchUpcoming } from '@/lib/content';
import { toUpcomingProduct } from '@/lib/upcoming';

/**
 * 后台维护的「待上新产品」。失败时返回 null，调用方回落到静态内容，
 * 避免后台短暂不可用时首页与产品页整块消失。
 */
export function useUpcomingProducts(): ProductEntry[] | null {
  const [items, setItems] = useState<ProductEntry[] | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    fetchUpcoming(controller.signal)
      .then((list) => {
        if (active) setItems(list.map(toUpcomingProduct));
      })
      .catch(() => {
        if (active) setItems(null);
      });
    return () => {
      active = false;
      controller.abort();
    };
  }, []);

  return items;
}
